export default __webpack_public_path__ + "static/media/Weather_11.498ff8b0.png";